import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import Header from "../components/Header";
import Footer from "../components/Footer";
import AdminChrome from "../components/AdminChrome";
import { useRequireAdmin } from "./AdminLogin";

function downloadJson(data, filename) {
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}

export default function AdminBackup() {
  useRequireAdmin();
  const [busy, setBusy] = useState("");
  const [message, setMessage] = useState("");
  const importRef = useRef(null);

  const exportData = async (kind) => {
    setBusy(kind); setMessage("");
    try {
      const { data } = await api.request({ url: kind === "full" ? "/admin/backup/full" : "/admin/export/public", method: kind === "full" ? "post" : "get" });
      downloadJson(data, kind === "full" ? "onemedia-backup.json" : "onemedia-public-export.json");
      setMessage("download ready");
    } catch (error) {
      setMessage(error.response?.data?.detail || "export failed");
    } finally { setBusy(""); }
  };

  const importBackup = async (file) => {
    if (!file) return;
    if (!window.confirm("Merge this backup into the current site? Records with matching IDs will be updated; unmatched current records will remain.")) return;
    setBusy("import"); setMessage("");
    try {
      const form = new FormData();
      form.append("file", file);
      const { data } = await api.post("/admin/backup/import", form, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setMessage(`merged ${Object.values(data.imported || {}).reduce((sum, count) => sum + count, 0)} records`);
    } catch (error) {
      setMessage(error.response?.data?.detail || "import failed");
    } finally {
      setBusy("");
      if (importRef.current) importRef.current.value = "";
    }
  };

  return (
    <div className="App">
      <Header />
      <main className="xs-page" data-testid="admin-backup-page">
        <div className="xs-container" style={{ maxWidth: 760 }}>
          <AdminChrome />
          <h1 style={{ margin: "0 0 4px", color: "#ffde16" }}>backup</h1>
          <p style={{ opacity: 0.8 }}>Download a complete operational backup or public content package. Imports merge matching IDs and keep unmatched current records.</p>
          <div className="xs-backup-actions">
            <button className="xs-btn primary" onClick={() => exportData("full")} disabled={Boolean(busy)} data-testid="backup-full">
              {busy === "full" ? "preparing..." : "download full backup"}
            </button>
            <button className="xs-btn ghost" onClick={() => exportData("public")} disabled={Boolean(busy)} data-testid="backup-public">
              {busy === "public" ? "preparing..." : "download public export"}
            </button>
            <button className="xs-btn danger" onClick={() => importRef.current?.click()} disabled={Boolean(busy)} data-testid="backup-import">
              {busy === "import" ? "merging..." : "merge full backup"}
            </button>
            <input
              ref={importRef}
              type="file"
              accept="application/json,.json"
              style={{ display: "none" }}
              onChange={(event) => importBackup(event.target.files?.[0])}
            />
          </div>
          {message && <div style={{ marginTop: 14, opacity: 0.8 }}>{message}</div>}
        </div>
      </main>
      <Footer show />
    </div>
  );
}
